/**
 * Customize to adjust styles on kit widget
 */

import { SxProps } from '@mui/material';

export const kitTableItemDetailsSX: Record<string, SxProps> = {
	cell: {
		py: '10px',
	},
	cellContainer: {
		borderRight: '1px solid',
		borderRightColor: 'grey.50',
		gap: '10px',
		flexDirection: 'row',
	},
	image: {
		minWidth: '90px',
		minHeight: '90px',
		width: '90px',
	},
	nameContainer: {
		pr: '10px',
		alignSelf: 'start',
	},
	sku: {
		color: 'grey.300',
		pt: '2px',
	},
};
